module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    class: 'avatar ' + _vm.size,
    attrs: {
      "to": _vm.linkUrl,
      "tag": "a",
      "title": _vm.profileData.alias
    }
  }, [(_vm.showXpInfo) ? _c('svg', {
    attrs: {
      "viewPort": "0 0 200 300",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "xp-ring",
    attrs: {
      "stroke-dasharray": _vm.xpRingProperties.strokeDasharray,
      "cx": _vm.xpRingProperties.cx,
      "cy": _vm.xpRingProperties.cy,
      "r": _vm.xpRingProperties.r
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "inner",
    attrs: {
      "src": _vm.imgSrc + '?v=' + _vm.profileData.avatarId,
      "alt": _vm.altText,
      "title": _vm.altText
    }
  }), _vm._v(" "), (_vm.showXpInfo) ? _c('div', {
    staticClass: "level"
  }, [_vm._v(_vm._s(_vm.profileData.xpLevelData.xpLevel))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21d45b58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Avatars/Avatar.vue
// module id = 834
// module chunks = 2